var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484.736 80.896c24.618667 0 48.981333 2.005333 72.917333 6.016l5.248 2.133333v61.013334a376.746667 376.746667 0 1 0 297.770667 343.765333l-1.024-12.288 60.8-5.930667c1.408 14.250667 2.133333 28.629333 2.133333 43.093334 0 241.792-196.053333 437.802667-437.845333 437.802666-241.792 0-437.802667-196.010667-437.802667-437.802666C46.933333 276.906667 242.944 80.896 484.693333 80.896zM576.426667 640.853333a30.549333 30.549333 0 1 1 0 61.056H311.637333a30.549333 30.549333 0 1 1 0-61.056h264.746667z m0-122.197333a30.549333 30.549333 0 1 1 0 61.098667H311.637333a30.549333 30.549333 0 1 1 0-61.098667h264.746667z m-81.493334-122.197333a30.549333 30.549333 0 1 1 0 61.098666H311.68a30.549333 30.549333 0 1 1 0-61.098666H494.933333z m131.328-329.002667l35.072 3.370667a347.733333 347.733333 0 0 1 312.405334 312.405333l3.413333 35.072h-350.890667V67.498667z m64 72.704v214.101333h214.101334l-1.450667-6.442666a284.16 284.16 0 0 0-206.165333-206.165334l-6.528-1.493333z",
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYield);
export default __webpack_public_path__ + "static/media/yield.efa7bb1ca80f33e84b1139fe56122cf6.svg";
export { ForwardRef as ReactComponent };